import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import KryzenHero from "../Components/Landing/hero";
import Footer from "../Components/Footer/footer";
import NewsletterSection from "../Components/Landing/newsletter";
import { getBlogBySlug } from "./blog_data";
import RandomPosts from "./random_posts";
import {
  AgriSubsidyCard,
  HydroponicWebinarCard,
  FarmSetupCard,
  Adcards,
} from "../Components/Sidebar Banner/sidebarBanner";
import { Helmet } from "react-helmet-async";
import LatestPosts from "./latest_posts";
export default function SinglePost() {
  const { slug } = useParams();
  const navigate = useNavigate();

  const [singlePost, setSinglePost] = useState(null);

  useEffect(() => {
    async function fetchLatest() {
      const data = await getBlogBySlug(slug);

      if (data?.length === 0) {
        navigate("/page-not-found");
      }

      setSinglePost(data);
    }
    fetchLatest();
  }, [slug]);

  // JSON-LD injection
  useEffect(() => {
    if (!singlePost) return; // only run when data is ready

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "BlogPosting",
      headline: singlePost.title,
      description: singlePost.description,
      keywords: singlePost.keywords,
      image: singlePost.featured_image || "https://kryzen.com/og-image.jpg",
      author: { "@type": "Organization", name: "Kryzen Info" },
      publisher: {
        "@type": "Organization",
        name: "Kryzen Info",
        logo: {
          "@type": "ImageObject",
          url: "https://kryzen.com/og-image.jpg",
        },
      },
      mainEntityOfPage: {
        "@type": "WebPage",
        "@id": `https://kryzen.info/${singlePost.post_type}/${singlePost.slug}`,
      },
      datePublished: singlePost.created_at,
      dateModified: singlePost.updated_at || singlePost.created_at,
      url: `https://kryzen.info/${singlePost.post_type}/${singlePost.slug}`,
      articleSection: singlePost.post_type,
    });

    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, [singlePost]);
  if (!singlePost) return <h2 className="text-center mt-5">Loading...</h2>;

  return (
    <>
      <Helmet>
        <title>{singlePost?.title}</title>
        <meta name="description" content={singlePost?.description} />
        <meta name="keywords" content={`${singlePost?.keywords}`} />
        <link
          rel="canonical"
          href={`https://kryzen.info/${singlePost?.post_type}/${singlePost?.slug}`}
        />

        <meta property="og:title" content={singlePost?.title} />
        <meta
          property="og:description"
          content="Leading hydroponics & agri-tech solutions in India."
        />
        <meta property="og:image" content="https://kryzen.com/og-image.jpg" />
        <meta
          property="og:url"
          content={`https://kryzen.info/${singlePost?.post_type}/${singlePost?.slug}`}
        />
        <meta property="og:type" content="website" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={singlePost?.title} />
        <meta name="twitter:description" content={singlePost?.excerpt} />
        <meta
          name="twitter:image"
          content="https://res.cloudinary.com/dfhuelkzw/image/upload/v1763957144/kryzen_info-logo_iudzc9.png"
        />
      </Helmet>
      <div className="page-wrapper container">
        <KryzenHero
          title="Empowering the Future of Smart & Sustainable Farming"
          subtitle="Kryzen Biotech is India’s leading hydroponics and agri-tech company delivering end-to-end solutions — from hydroponic farm development and automation systems to AI-powered farm management, commercial training, and advanced agri tools."
          buttonText="🌿 Join Newsletter"
          buttonLink="#newsletter"
          background="bg-light"
        />
        <div className="row ">
          <div className="col-12 col-md-8 col-lg-8 border-0 border-0 border-md-end border-dark border-1">
            <h1 className="ps-4 pe-4">{singlePost?.title}</h1>
            <div
              dangerouslySetInnerHTML={{ __html: singlePost?.content }}
              className="ps-4 pe-4 mt-4 fs-3"
            />
            <div></div>
          </div>
          {/* Sidbebar */}
          <div className="col-12 col-md-4 col-lg-4 mt-4 mt-md-0 mt-lg-0  sidebar px-4 px-md-0 px-lg-0">
            <Adcards />
            <div>
              <h2 className="mt-4 fs-1">Trending Articles</h2>

              <RandomPosts />
            </div>
            {/* <div>
               <KryzenSocialCard />
            </div> */}
            {/* <div>

            <SharkTankKryzenVideo />
          </div> */}

            {/* <div>
            <GalleryCard />
          </div> */}
            {/* <div>
<GalleryCarouselCard />

          </div> */}

            <div className="mt-2">
              <AgriSubsidyCard />
            </div>
            <div>
              <HydroponicWebinarCard />
            </div>
            <div>
              <FarmSetupCard />
            </div>
          </div>
        </div>
       
        <hr className="border border-1 border-dark" />
        <LatestPosts />

        {/* <TrendingPost /> */}
        <NewsletterSection />
        <Footer />
      </div>
    </>
  );
}
